<!-- successPart -->
<template>
  <div class="wrapper">
    <div class="title">
      <img
        src="../../../assets/img/payment/sigh.png"
        alt=""
      />
      <div>恭喜获得专属题库，快去体验吧</div>
    </div>
    <div class="content">
      <div
        class="group"
        v-for="(subject, index) in subjectArr"
        :key="index"
      >
        <div class="subTitle">{{ subject.subjectName }}</div>
        <question-bank-item
          v-for="(paperListItem, index) in subject.tabVOList"
          :key="index"
          :paperListItem="paperListItem"
        />
      </div>
    </div>
  </div>
</template>

<script>
import questionBankItem from './questionBankItem.vue';

export default {
  components: { questionBankItem },
  props: {
    subjectArr: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
    };
  },
  watch: {
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  margin-top: 60px;
  padding: 0 36px 42px 36px;

}
.title {
  display: flex;
  align-items: center;
  margin-bottom: 29px;

  img {
    width: 36px;
    height: 36px;
  }

  div {
    margin-left: 2px;
    font-size: 29px;
    font-weight: 500;
    color: #333333;
    line-height: 40px;
  }
}

.group {
  margin-bottom: 36px;
}

.content {
  width: 100%;
  padding: 25px 29px 36px;
  background: linear-gradient(47deg, #FFF9F7 0%, #FFF2EC 100%);
  border-radius: 7px;

  .subTitle {
    font-size: 25px;
    font-weight: 500;
    color: #333333;
    line-height: 36px;
  }
}
</style>
